<template>
  <a :href="homeUrl" :title="appTitle">
    <img :src="appIcon" alt="Logo" class="af-app-logo" />
  </a>
</template>

<script>
import { mapState } from "pinia";
import { useAppStore } from "../../store/app";

export default {
  name: "AppLogo",

  data() {
    return {
      homeUrl: process.env.VUE_APP_NLX_SERVER
    }
  },

  computed: {
    ...mapState(useAppStore, {
      appIcon: (store) =>
        store.config.appIcon || require("../../assets/img/logo.svg"),
      appTitle: (store) => store.config.appTitle,
    }),
  },
};
</script>
